// Libs
import { useEffect, useMemo, useState } from "react";
import classNames from "classnames";

// Components
import { Button } from "../../components/Button/Button";
import Input from "../../components/Input/Input";

import styles from "./Search.module.scss";
import { useLocation } from "react-router-dom";

export interface SearchProps {
  className?: string;
  onSearch: (query: string, location: string) => void;
  onClear: () => void;
}

export const Search: React.FunctionComponent<SearchProps> = ({
  className = "",
  onSearch,
  onClear,
}) => {
  const [queryClear, setQueryClear] = useState(false);
  const [locationClear, setLocationClear] = useState(false);
  const [query, setQuery] = useState("");
  const [location, setLocation] = useState("");

  const domLocation = useLocation();

  const queryParams = useMemo(() => {
    const params = new URLSearchParams(domLocation.search);
    const searchParam = params.get("q");
    const locationParam = params.get("l");

    return { searchParam, locationParam };
  }, [domLocation.search]);

  const clearQueryFiled = () => {
    setQuery("");
    setQueryClear(false);
    onClear();
  };

  const clearLocationField = () => {
    setLocation("");
    setLocationClear(false);
    onClear();
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      if (query === "" && location === "") onClear();
      else onSearch(query, location);
    }
  };

  useEffect(() => {
    const { searchParam, locationParam } = queryParams;

    if (searchParam) {
      setQuery(searchParam);
      setQueryClear(true);
    } else {
      setQuery("");
      setQueryClear(false);
    }

    if (locationParam) {
      setLocation(locationParam);
      setLocationClear(true);
    } else {
      setLocation("");
      setLocationClear(false);
    }
  }, [queryParams]);

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.search}>
        <Input
          value={query}
          className={styles.input}
          placeholder="Pojam za pretragu"
          type="search"
          onChange={(e) => {
            setQueryClear(true);
            if (e.target.value === "") setQueryClear(false);
            setQuery(e.target.value);
          }}
          onKeyDown={handleKeyDown}
        />
        <div
          className={classNames(
            styles.clear,
            queryClear ? styles.show : styles.hide
          )}
          onClick={clearQueryFiled}
        ></div>
      </div>
      <div className={styles.location}>
        <Input
          value={location}
          className={styles.input}
          placeholder="Lokacija"
          type="location"
          onKeyDown={handleKeyDown}
          onChange={(e) => {
            setLocationClear(true);
            if (e.target.value === "") setLocationClear(false);
            setLocation(e.target.value);
          }}
        />
        <div
          className={classNames(
            styles.clear,
            locationClear ? styles.show : styles.hide
          )}
          onClick={clearLocationField}
        ></div>
      </div>

      <div className={styles.action}>
        <Button
          type="primary"
          className={styles.button}
          onClick={() => onSearch(query, location)}
        >
          Pretraži
        </Button>
      </div>
    </div>
  );
};
